import TabsLinks from '../components/TabsLinks';

const TabsLinkPage = () => {
  return <TabsLinks />;
};

export default TabsLinkPage;
